export var searchNestedProperties = function (queryStringArray, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
searchObject) {
    if (queryStringArray === void 0) { queryStringArray = []; }
    if (searchObject === void 0) { searchObject = {}; }
    return queryStringArray.reduce(function (parent, child) {
        if (parent && parent[child]) {
            return parent[child];
        }
        return null;
    }, searchObject);
};
